import { render, staticRenderFns } from "./CurrentReport.vue?vue&type=template&id=860feda4&scoped=true&"
import script from "./CurrentReport.vue?vue&type=script&lang=js&"
export * from "./CurrentReport.vue?vue&type=script&lang=js&"
import style0 from "./CurrentReport.vue?vue&type=style&index=0&id=860feda4&lang=scss&scoped=true&"
import style1 from "./CurrentReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860feda4",
  null
  
)

export default component.exports